export default "__VITE_ASSET__tEf6MSlM__"